import React, { Component } from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";

import ApiNgos from "../../utils/api.ngos";
import AuthService from "../../utils/auth.service";
import ShowValue from "../../components/ShowValue";
import ApiAssets from "../../utils/api.assets";
import Loading from "../../components/Loading";
import MessageModal from "../../components/Message";

class ProfilePage extends Component {
  FIXED_RESERVED = 10000;

  constructor(props) {
    super(props);

    this.state = {
      img_url: AuthService.registerData.photoURL,
      profile: AuthService.currentUser,
      ngos: [],
      profile_classets: {
        my_classets: [],
        prev_classets: [],
        auction_classets: []
      },
      modal: {
        isOpen: false,
        title: "",
        message: ""
      },
      loading: true,
      adminSiteClicks: {}
    };

    ApiNgos.get().then(response => {
      if (response.data) {
        this.setState(...this.state, { ngos: response.data });
      }
    });

    document.addEventListener("profileLoaded", data => {
      if (data.detail) {
        this.setState(...this.state, {
          profile: data.detail.profile
        });
      }
    });

    ApiAssets.getMy().then(response => {
      if (response.data) {
        let total_asset_value = 0;

        response.data.my_classets.forEach(classet => {
          total_asset_value += classet.info.previous_landers[0].previous_lander_asset_price * 1.2;
        });

        this.setState(...this.state, {
          loading: false,
          total_asset_value: total_asset_value,
          profile_classets: response.data
        });
      }
    }).catch(error => {
      this.setState(...this.state, {
        loading: false,
      });
    });

    this.handleInput = this.handleInput.bind(this);
    this.handleSubmitProfile = this.handleSubmitProfile.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.clicksToAdminSite = this.clicksToAdminSite.bind(this);
  }

  clicksToAdminSite(type) {
    if (type !== undefined && type !== null) {
      let clicks = this.state.adminSiteClicks[type];
      if (clicks) {
        clicks++;
        if (clicks > 5) {
          window.open('https://cryptolands-d51d1-ad1m1.firebaseapp.com/');
          clicks = 1;
        }
      } else {
        clicks = 1;
      }
      this.setState(...this.state, {
        adminSiteClicks: {
          [type]: clicks
        }
      });
    }
  }

  toggleAlert() {
    this.setState(...this.state, {
      modal: { isOpen: !this.state.modal.isOpen }
    });
  }

  handleInput(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    let profile = this.state.profile;
    profile[name] = value;

    this.setState(...this.state, {
      profile: profile
    });
  }

  handleSubmitProfile() {
    this.setState(...this.state, { loading: true });

    AuthService.update(this.state.profile, "regular").then(data => {
      this.setMessage("All changes were saved", data.message);
    }).catch(() => {
      this.setMessage(
        "Ooppps",
        "Something happened, but we are taking care about it, try again soon"
      );
    });
  }

  setMessage(title, message) {
    this.setState(...this.state, {
      modal: {
        title: title,
        message: message,
        isOpen: true
      },
      loading: false
    });
  }

  handleBack() {
    this.props.history.goBack();
  }

  render() {
    return (
      <section className="profile-page">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <h4 className="pt-4">My Profile</h4>
              <button onClick={this.handleBack} className="btn btn-outline-secondary float-right">
                Back
              </button>{" "}
              {/* Back */}
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-2">
              <img className="img-fluid rounded-circle mt-2" alt="decorative profile" src={this.state.img_url} onClick={() => { this.clicksToAdminSite('go-to-admin') }} />
            </div>{" "}
            {/* Image */}
            <div className="col-md-6">
              <label htmlFor="name">Cryptolander's name:</label>
              <input type="text" className="form-control mb-2" onChange={this.handleInput} value={this.state.profile.name} name="name" />
              <div className="row justify-content-center">
                <div className="col-md-6">
                  <label htmlFor="upside">
                    Price Increase ({Number(this.state.profile.donation) + 40}%)
                  </label>
                  <input type="range" min="20" max="60" step="5" onChange={this.handleInput} value={this.state.profile.donation} name="donation" />
                </div>{" "}
                {/* Default Price Increase */}
                <div className="col-md-6">
                  <label htmlFor="ngo">Prefered NGO</label>
                  <select name="ngo" onChange={this.handleInput} value={this.state.profile.ngo} className="form-control" >
                    {this.state.ngos.map(ngo => (
                      <option key={ngo.key} value={ngo.key}>
                        {ngo.name}{" "}
                      </option>
                    ))}
                  </select>
                </div>{" "}
                {/* Prefered NGO */}
              </div>
            </div>{" "}
            {/* Name + Price Increase + NGO */}
          </div>{" "}
          {/* Body */}
          <div className="row justify-content-center">
            <div className="col-md-8">
              <hr />
              <Button className="float-right" color="secondary ml-2" onClick={() => this.handleSubmitProfile()} type="submit">
                Save
              </Button>{" "}
              {/* Save */}
            </div>
          </div>{" "}
          {/* Buttons */}
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-4">
              <h4 className="pt-4">My Classets</h4>
              <hr />
              <ul className="list-unstyled m-0 p-0" hidden={this.state.profile_classets.my_classets.length === 0}>
                {this.state.profile_classets.my_classets.map((land, index) => (
                  <Link key={index} onClick={this.props.toggle} to={"/assets/?assetline=" + land.assetline} >
                    <div className="row row-item" key={land.info.name}>
                      <div className="col-md-3">
                        <img className="img-fluid" src={land.info.image} />
                      </div>
                      <div className="col-md-9">
                        {land.info.name} <br />
                        Sell Price:{" "}
                        <ShowValue btc={land.info.previous_landers[0].previous_lander_asset_price} />
                        <br />
                      </div>
                    </div>
                  </Link>
                ))}
              </ul>
              <p hidden={this.state.profile_classets.my_classets.length !== 0}>
                Not yet a Cryprolander? Buy one asset!
              </p>
            </div>{" "}
            {/* My Classets */}
            <div className="col-md-4">
              <h4 className="pt-4">My Previous Classets</h4>
              <hr />
              <ul className="list-unstyled m-0 p-0" hidden={this.state.profile_classets.prev_classets.length === 0} >
                {this.state.profile_classets.prev_classets.map(land => (
                  <Link onClick={this.props.toggle} to={"/assets/?assetline=" + land.assetline}>
                    <div className="row row-item" key={land.info.name}>
                      <div className="col-md-3">
                        <img className="img-fluid" src={land.info.image} />
                      </div>
                      <div className="col-md-9">
                        {land.info.name} <br />
                      </div>
                    </div>
                  </Link>
                ))}
              </ul>
              <p hidden={this.state.profile_classets.prev_classets.length !== 0} >
                You did not sell any asset... yet
              </p>
            </div>{" "}
            {/* Previous Assets */}
            <div className="col-md-8">
              <hr />
              <p className="float-right">
                Total:
                <strong>
                  {" "}
                  <ShowValue btc={this.state.total_asset_value} />
                </strong>
              </p>
            </div>{" "}
            {/* Balance when sold */}
          </div>

          <div className="row justify-content-center">
            <div className="col-md-4">
              <h4 className="pt-4">My Offers</h4>
              <hr />
              <ul className="list-unstyled m-0 p-0" hidden={this.state.profile_classets.auction_classets.length === 0}>
                {this.state.profile_classets.auction_classets.map(land => (
                  <Link onClick={this.props.toggle} to={"/assets/?assetline=" + land.assetline}>
                    <div className="row row-item" key={land.info.name}>
                      <div className="col-md-3">
                        <img className="img-fluid" src={land.info.image} />
                      </div>
                      <div className="col-md-9">
                        {land.info.name} <br />
                        Your Offer: <ShowValue btc={land.value} />
                        <br />
                        Reserved:{" "}
                        <ShowValue btc={land.value + this.FIXED_RESERVED} />
                      </div>
                    </div>
                  </Link>
                ))}
              </ul>
              <p hidden={this.state.profile_classets.auction_classets.length !== 0} >
                You did not make any offer... yet
              </p>
            </div>{" "}
            {/* Auction Assets */}
            <div className="col-md-4" />
          </div>
        </div>
        <Loading active={this.state.loading} />
        <MessageModal isOpen={this.state.modal.title} toggle={this.toggleAlert} title={this.state.modal.title} message={this.state.modal.message} />
      </section>
    );
  }
}

export default ProfilePage;



// WEBPACK FOOTER //
// ./src/containers/ProfilePage/index.js